module.exports = __webpack_public_path__ + "assets/img/lexin-loader.ec5f0203.gif";